var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 20.7333L14 20.8667L13.8533 20.7333C7.51996 14.9867 3.33329 11.1867 3.33329 7.33333C3.33329 4.66667 5.33329 2.66667 7.99996 2.66667C10.0533 2.66667 12.0533 4 12.76 5.81333H15.24C15.9466 4 17.9466 2.66667 20 2.66667C22.6666 2.66667 24.6666 4.66667 24.6666 7.33333C24.6666 11.1867 20.48 14.9867 14.1333 20.7333ZM20 0C17.68 0 15.4533 1.08 14 2.77333C12.5466 1.08 10.32 0 7.99996 0C3.89329 0 0.666626 3.21333 0.666626 7.33333C0.666626 12.36 5.19996 16.48 12.0666 22.7067L14 24.4667L15.9333 22.7067C22.8 16.48 27.3333 12.36 27.3333 7.33333C27.3333 3.21333 24.1066 0 20 0Z",
    fill: "#E03F59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeart);
export default __webpack_public_path__ + "static/media/filled_heart.60b6d39573c8af30636da19436a72615.svg";
export { ForwardRef as ReactComponent };